import { useState } from "react";
import SaveButton from "../../Components/SaveButton";
import type { Restaurant } from "../../Manager/restaurant.types";
import { getOpenStatus } from "../SingleRest/OpeningHours";
import RenderStars from "./RenderStars";
import { ImageOff } from "lucide-react";

interface RestCardProps {
  restaurant: Restaurant;
  size?: number;
  onCardClick: (id: string, name: string) => void;
}

const RestCard = ({ restaurant, onCardClick, size = 24 }: RestCardProps) => {
  const [timeStatus, setTimeStatus] = useState<string>()
  const getCuisineString = (restaurant: Restaurant) => {
    const allLabels = [
      ...(restaurant.typeOfFood ?? []),
      ...(restaurant.experience ?? []),
      ...(restaurant.cuisine ?? []),
    ].filter(Boolean);

    if (allLabels.length === 0) return '';

    const shuffled = [...allLabels].sort(() => 0.5 - Math.random());
    return shuffled.slice(0, 3).join(', ');
  };

  const cuisineString = getCuisineString(restaurant);
  const metadataRating = typeof restaurant.googleMetadata?.rating === 'number'
    ? restaurant.googleMetadata.rating
    : null;
  const overallRating = metadataRating ?? restaurant.rating?.average ?? 0;
  
  return (
    <div className="flex gap-3 p-2 bg-white rounded-xl shadow-sm active:shadow-md transition-shadow" onClick={() => onCardClick(restaurant._id, restaurant.name)}>
      <div className="relative">
        <div className="absolute top-1 right-1">
          <SaveButton restaurantId={restaurant._id} stroke='white' size={6} />
        </div>
        {restaurant.gallery?.cover?.url ? (
          <img 
            src={restaurant.gallery?.cover?.url || '/placeholder-image.jpg'}
            alt={restaurant.name}
            className={`w-${size} h-${size} object-cover rounded-md flex-shrink-0`}
          />
        ) : (
          <div className={`w-${size} h-${size} bg-gray-200 rounded-md flex items-center justify-center flex-shrink-0`}>
            <div className="flex flex-col items-center">
            <ImageOff className="text-gray-400" size={20} />
            <span className="text-xs text-gray-500">Help us improve</span>
            </div>
          </div>
        )}
      </div>
      <div className="flex-1 min-w-0">
        <h3 className="font-semibold text-gray-900 truncate">{restaurant.name}</h3>
        <div className="flex items-center gap-1">
          <span className="text-sm text-gray-900">
            {overallRating.toFixed(1)}
          </span>
          <div className="flex items-center">
            <RenderStars rating={overallRating} size={12} />
          </div>
          {restaurant.viewCount && <span className="text-xs text-gray-900">{`(${restaurant.viewCount})`}</span>}
        </div>
        <div className="text-sm text-gray-600">
          From Ksh {restaurant.priceRange.min.toLocaleString()} • <span>{cuisineString}</span>
        </div>
        {restaurant?.openingHours && <span className={`text-xs ${(getOpenStatus(restaurant?.openingHours).toString()).startsWith("Open") ? "text-green-600" : "text-red-600"}`}>{getOpenStatus(restaurant?.openingHours).toString()}</span>}
      </div>
    </div>
  );
};

export default RestCard;